// The sidebar's icon rail (US 9372). The user's choice is remembered in this browser; some pages
// (e.g. a project page) switch to the rail for more room and call restoreRail() when they are left.

const RAIL_KEY = 'sidebarCollapsed';
const RAIL_CLASS = 'sidebar-collapsed';

export function railPreference() {
  try {
    return localStorage.getItem(RAIL_KEY) === '1';
  } catch (e) {
    return false;
  }
}

export function setRail(on, remember) {
  let app = document.getElementById('app');
  if (app) {
    app.classList.toggle(RAIL_CLASS, on);
  }
  if (remember) {
    try {
      localStorage.setItem(RAIL_KEY, on ? '1' : '0');
    } catch (e) {
      // Remembering the rail is only a convenience
    }
  }
}

export function restoreRail() {
  setRail(railPreference(), false);
}

export function isRail() {
  let app = document.getElementById('app');
  return !!app && app.classList.contains(RAIL_CLASS);
}
